// extracted by mini-css-extract-plugin
export default {"table":"sJjsdnNy","wrap":"J0PJmJJi"};